import request from '@/utils/request'

/**
 * 查询热点人物
 * @param {*} data
 * @returns
 */
export function hotPerson (data) {
  return request({
    url: '/zstp/neo4j/hot_person/',
    method: 'post',
    data
  })
}

/**
 * 首页人物关系查询
 * @param {*} data
 * @returns
 */
export function homeRelation (data) {
  return request({
    url: '/zstp/neo4j/home_relation/',
    method: 'post',
    data
  })
}

/**
 * 查询人物关系
 * @param {*} data
 * @returns
 */
export function personRelation (data, others = {}) {
  return request({
    url: '/zstp/neo4j/person_relation/',
    method: 'post',
    ...others,
    data
  })
}

/**
 * 人物足迹
 * @param {*} data
 * @returns
 */
export function personAddressRelation (data, others = {}) {
  return request({
    url: '/zstp/neo4j/person_address_relation/',
    method: 'post',
    ...others,
    data
  })
}

/**
 * 查询人物详情
 * @param {*} data
 * @returns
 */
export function personDetail (data) {
  return request({
    url: '/zstp/neo4j/person_detail/',
    method: 'post',
    data
  })
}

/**
 * 时间图谱
 * @param {*} data
 * @returns
 */
export function timeGraph (data) {
  return request({
    url: '/zstp/neo4j/time_graph/',
    method: 'post',
    data
  })
}

/**
 * 关系发现
 * @param {*} data
 * @returns
 */
export function relationDiscovery (data) {
  return request({
    url: '/zstp/neo4j/relation_discovery/',
    method: 'post',
    data
  })
}

/**
 * 人物关系
 * @param {*} data
 * @returns
 */
export function personRelationSidebar (data) {
  return request({
    url: '/zstp/neo4j/person_relation_sidebar/',
    method: 'post',
    data
  })
}

/**
 * 高级搜索
 * @param {*} data
 * @returns
 */
export function advancedSSearch (data) {
  return request({
    url: '/zstp/neo4j/advanced_search/',
    method: 'post',
    data
  })
}

/**
 * 获取用户信息
 * @returns
 */
export function userInfo () {
  return request({
    url: '/zstp/neo4j/get_user_info/',
    method: 'post'
  })
}

/**
 * 查询记载于
 * @returns
 */
export function getRecordedIn (data) {
  return request({
    url: '/zstp/neo4j/get_recorded_in/',
    method: 'post',
    data
  })
}

/**
 * 查询下级关系
 * @param {*} data
 * @returns
 */
export function getPersonNextRelation (data) {
  return request({
    url: '/zstp/neo4j/get_person_next_relation/',
    method: 'post',
    data
  })
}

/**
 * 查询名称对应的地点列表列表
 * @param {*} data
 * @returns
 */
export function nameAddress (data) {
  return request({
    url: '/zstp/neo4j/get_name_address/',
    method: 'post',
    data
  })
}

/**
 * 任务模糊查询
 * @param {*} data
 * @returns
 */
export function personSearch (data) {
  return request({
    url: '/zstp/neo4j/get_name_search/',
    method: 'post',
    data
  })
}

/**
 * 热门地点
 * @param {*} data
 * @returns
 */
export function hotAddress (data) {
  return request({
    url: '/zstp/neo4j/hot_address/',
    method: 'post',
    data
  })
}

/**
 * 地点关系导出
 * @param {*} data
 * @returns
 */
export function exportAction (data, others = {}) {
  return request({
    url: '/zstp/neo4j/relation_discovery/',
    method: 'post',
    ...others,
    data
  })
}
